import { toLower } from 'lodash-es'
import { trim, defaultTo } from './bits'

import deline from './deline'
import extractRawElm from './extract-raw-elm'

const squashSpaces = (line = '') => line.replace(/\s{2,}/g, ' ')

export function getElmStr($elm) {
  return getElmStrWithAttrs($elm, null)
}

export function getElmStrShort($elm) {
  return getElmStrWithAttrs($elm, ['class', 'id'])
}

export function getElmStrWithAttrs($elm, allowedAttrs) {
  const elm = extractRawElm($elm)

  if (!elm.attributes) {
    let str = `<${toLower(elm.nodeName)}`
    str += ` ${trim(elm.nodeValue)}`
    str += '>'
    if (elm.parentNode) str += ` child of ${getElmStrWithAttrs(elm.parentNode, allowedAttrs)}`
    return str
  }

  let str = `<${toLower(elm.nodeName)}`

  for (const attr of elm.attributes) {
    if (allowedAttrs && (allowedAttrs.indexOf(attr.name) === -1)) {
      continue
    }

    str += ` ${attr.name}="${attr.value}"`
  }

  str += '>'

  const res = squashSpaces(deline(str))
  return res
}

export function getElmSign($elm) {
  const elm = extractRawElm($elm)
  const elmSign = defaultTo(elm.id, elm.className, elm.tagName)
  return elmSign
}
